// src/data/legacyAnnouncementImages.js
// Images for announcements that existed before the page moved to Firestore.
//
// These ship with the app (imported at build time). Announcements added through
// the admin panel from now on store their image in Firebase Storage instead,
// and their `imageUrl` takes priority over anything here.
//
// Keyed by a stable slug stored on each record as `legacyImageKey`.

import MarvelImg from "../assets/blog/marvel.jpg";
import CaribbeanCupImg from "../assets/blog/caribbean cup.JPG";
import DraftWarsImg from "../assets/blog/draftwars.JPG";
import OneVOneImg from "../assets/blog/1v1.JPG";
import OneVOneFemaleImg from "../assets/blog/1v1female.JPG";
import OneVOneSEImg from "../assets/blog/1v1 SE.JPG";
import OneVOneAcademyImg from "../assets/blog/1v1 academy.JPG";
import ThreeVThreeImg from "../assets/blog/3v3.JPG";
import DuosImg from "../assets/blog/duos.JPG";
import TriosImg from "../assets/blog/trios.JPG";
import TriosCompImg from "../assets/blog/trios comp.JPG";

export const LEGACY_ANNOUNCEMENT_IMAGES = {
  "caribbean-cup": CaribbeanCupImg,
  marvel: MarvelImg,
  "draft-wars": DraftWarsImg,
  "1v1": OneVOneImg,
  "1v1-female": OneVOneFemaleImg,
  "1v1-se": OneVOneSEImg,
  "1v1-academy": OneVOneAcademyImg,
  "3v3": ThreeVThreeImg,
  duos: DuosImg,
  trios: TriosImg,
  "trios-comp": TriosCompImg,
};
